import React, { useEffect, useState, useRef } from "react";
import { Nav, Tab, Row, Col, Container } from "react-bootstrap";
import DashboardLayout from "../DashboardLayout";
import { useNavigate, useParams } from "react-router-dom";
import BasicInformation from "./basicInfo";
import ServiceInformation from "./serviceInfo";
import CompanyInformation from "./companyInfo";
import Documents from "./documents";
import { fetchEmployeeById } from "../../services/axios/apiManager";
import { handleErrors, setUserData } from "../../services/dataManager";
import LoadingSpinner from "../../Components/spinner";
import { toast } from "sonner";
import {
  getCities,
  getCountries,
  getProvinces,
  haveToCheckEmail,
  saveEmployeeData,
} from "./helpers";
import { useAppContext } from "../../services/context";

function AddEmployee() {
  const { id, tab } = useParams();
  const { setState, state } = useAppContext();
  const { user } = state;
  const navigate = useNavigate();
  const [empData, setEmpData] = useState({});
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [emailExist, setEmailExist] = useState(false);
  const [empEmail, setEmpEmail] = useState("");
  const formRefs = useRef({});
  const [documentsValues, setDocumentsValues] = useState({});
  const [activeTab, setActiveTab] = useState(tab || "basicInfo");

  const handleSaveForm = async (values) => {
    if (!id) {
      const currentForm = formRefs.current["basicInfo"];
      const errors = await currentForm.validateForm();
      if (Object.keys(errors).length > 0) {
        currentForm.setTouched(errors);
        toast.error("Please review and fix the fields values.", {
          duration: 2000,
        });
        setActiveTab("basicInfo");
        navigate(`/AddEditEmployee/basicInfo/${id || ""}`, { replace: true });
        return;
      }
    }
    const data = { ...empData, ...values };
    const isEmailExists = await haveToCheckEmail(data, empEmail, navigate);
    if (isEmailExists) {
      setActiveTab("basicInfo");
      formRefs?.current?.basicInfo?.setFieldError(
        "email",
        "Email already exists"
      );
    } else {
      let docs = documentsValues
        ? Object.keys(documentsValues).reduce((acc, key) => {
            const value = documentsValues[key];
            if (value !== "" && value !== null && value !== undefined) {
              acc[key] = value;
            }
            return acc;
          }, {})
        : {};
      let temp = data
        ? Object.keys(data).reduce((acc, key) => {
            const value = data[key];
            if (value !== "" && value !== null && value !== undefined) {
              acc[key] = value;
            }
            return acc;
          }, {})
        : {};

      await saveEmployeeData(
        id,
        temp,
        docs,
        image,
        navigate,
        setEmpData,
        activeTab
      );
      if (id == user?.id) {
        const res = await fetchEmployeeById(id);
        if (res?.data?.success && res?.data?.data) {
          setUserData(res.data.data);
          setState((prev) => ({ ...prev, user: res.data.data }));
        }
      }
    }
  };

  const handleTabSwitch = async (nextTab) => {
    const currentForm = formRefs.current[activeTab];

    if (currentForm) {
      if (!id) {
        return;
      }

      if (activeTab != "documents") {
        let temp = currentForm?.values
          ? Object.keys(currentForm.values).reduce((acc, key) => {
              const value = currentForm.values[key];
              if (value !== "" && value !== null && value !== undefined) {
                acc[key] = value;
              }
              return acc;
            }, {})
          : {};

        if (activeTab === "companyInfo") {
          const FinancialInfo = {
            basic_salary: temp.basic_salary,
            gross_salary: temp.gross_salary,
            hourly_rate: temp.hourly_rate,
            bank_account_title: temp.bank_account_title,
            IBAN: temp.IBAN,
          };
          setEmpData((prev) => ({
            ...prev,
            FinancialInfo: FinancialInfo,
            department_id: temp.department_id,
            designation_id: temp.designation_id,
          }));
        } else {
          setEmpData((prev) => ({
            ...prev,
            ...temp,
          }));
        }
      }
      setActiveTab(nextTab);
      navigate(`/AddEditEmployee/${nextTab}/${id || ""}`, { replace: true });
      // }
    }
  };

  const handleNextTab = () => {
    if (activeTab === "basicInfo") {
      setActiveTab("serviceInfo");
      navigate(`/AddEditEmployee/serviceInfo/${id || ""}`, { replace: true });
    } else if (activeTab === "serviceInfo") {
      setActiveTab("companyInfo");
      navigate(`/AddEditEmployee/companyInfo/${id || ""}`, { replace: true });
    } else if (activeTab === "companyInfo") {
      setActiveTab("documents");
      navigate(`/AddEditEmployee/documents/${id || ""}`, { replace: true });
    }
  };

  const handlePreviousTab = () => {
    if (activeTab === "documents") {
      setActiveTab("companyInfo");
      navigate(`/AddEditEmployee/companyInfo/${id || ""}`, { replace: true });
    } else if (activeTab === "companyInfo") {
      setActiveTab("serviceInfo");
      navigate(`/AddEditEmployee/serviceInfo/${id || ""}`, { replace: true });
    } else if (activeTab === "serviceInfo") {
      setActiveTab("basicInfo");
      navigate(`/AddEditEmployee/basicInfo/${id || ""}`, { replace: true });
    }
  };

  const getData = async () => {
    await getCountries(setCountries, navigate);
    if (id) {
      const res = await fetchEmployeeById(id);
      if (res?.data?.success && res?.data?.data) {
        setEmpData(res.data.data);
        setEmpEmail(res.data.data.email);
        const { province_id, country_id } = res.data.data;
        if (country_id) {
          await getProvinces(country_id, setProvinces, navigate);
        }
        if (province_id) {
          await getCities(province_id, setCities, navigate);
        }
      } else {
        handleErrors(res, navigate);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <DashboardLayout>
      <div>
        <div className="col-12 mb-3">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>Employees</a>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#d1cdcdbf" }}
                >
                  {id ? "Edit Employee" : "Create Employee"}
                </li>
              </ol>
            </div>
          </div>
        </div>
        <Container>
          <div className="text-light min-vh-100">
            <Tab.Container activeKey={activeTab}>
              <Row className="bg-dark p-4 rounded mb-4">
                <Col sm={12}>
                  <Nav variant="tabs" className="bg-dark text-light">
                    <Nav.Item>
                      <Nav.Link
                      data-testid="infoHeading"
                        eventKey="basicInfo"
                        onClick={async (e) => {
                          e.preventDefault();
                          await handleTabSwitch("basicInfo");
                        }}
                        className={({ isActive }) =>
                          isActive ? "bg-success text-light" : ""
                        }
                        style={{ color: "#808080", opacity: 1 }}
                      >
                        Basic Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="serviceInfo"
                        data-testid="serviceInfo"
                        onClick={async (e) => {
                          e.preventDefault();
                          await handleTabSwitch("serviceInfo");
                        }}
                        className={({ isActive }) =>
                          isActive ? "bg-success text-light" : ""
                        }
                        style={{ color: "#808080", opacity: 1 }}
                      >
                        Service Info
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="companyInfo"
                        data-testid="companyInfo"
                        onClick={async (e) => {
                          e.preventDefault();
                          await handleTabSwitch("companyInfo");
                        }}
                        className={({ isActive }) =>
                          isActive ? "bg-success text-light" : ""
                        }
                        style={{ color: "#808080", opacity: 1 }}
                      >
                        Company Info
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="documents"
                        data-testid="documentsAttachments"
                        onClick={async (e) => {
                          e.preventDefault();
                          await handleTabSwitch("documents");
                        }}
                        className={({ isActive }) =>
                          isActive ? "bg-success text-light" : ""
                        }
                        style={{ color: "#808080", opacity: 1 }}
                      >
                        Documents / Attachments
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>

                <Col sm={12}>
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                      <LoadingSpinner size={"lg"} />
                    </div>
                  ) : (
                    <Tab.Content>
                      <Tab.Pane eventKey="basicInfo" className="mt-4">
                        <BasicInformation
                          formikRef={formRefs}
                          activeTab={activeTab}
                          handleNextTab={handleNextTab}
                          handlePreviousTab={handlePreviousTab}
                          setImage={setImage}
                          setEmpData={setEmpData}
                          empData={empData}
                          countries={countries}
                          provinces={provinces}
                          cities={cities}
                          setProvinces={setProvinces}
                          setCities={setCities}
                          submitEntireForm={handleSaveForm}
                          emailExist={emailExist}
                          setEmailExist={setEmailExist}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="serviceInfo" className="mt-4">
                        <ServiceInformation
                          formikRef={formRefs}
                          activeTab={activeTab}
                          handleNextTab={handleNextTab}
                          handlePreviousTab={handlePreviousTab}
                          setEmpData={setEmpData}
                          empData={empData}
                          submitEntireForm={handleSaveForm}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="companyInfo" className="mt-4">
                        <CompanyInformation
                          formikRef={formRefs}
                          activeTab={activeTab}
                          handleNextTab={handleNextTab}
                          handlePreviousTab={handlePreviousTab}
                          setEmpData={setEmpData}
                          empData={empData}
                          submitEntireForm={handleSaveForm}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="documents" className="mt-4">
                        <Documents
                          formikRef={formRefs}
                          activeTab={activeTab}
                          handlePreviousTab={handlePreviousTab}
                          submitEntireForm={handleSaveForm}
                          setDocumentsValues={setDocumentsValues}
                        />
                      </Tab.Pane>
                    </Tab.Content>
                  )}
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </Container>
      </div>
    </DashboardLayout>
  );
}

export default AddEmployee;
